<template>
    <div
        class="block px-3 py-1 text-sm leading-6 text-primary hover:bg-surface--light"
        data-spec-class="device_usage-card__customer-reference-edit"
    >
        <slot></slot>
    </div>
</template>
